/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_ForcedInputs */



/**
* | output |
* | --- |
* | "Forced Narrative" |
*
* @param {Metadata_Merge_ForcedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_forced = /** @type {((inputs?: Metadata_Merge_ForcedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_ForcedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Narration forcée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erzwungene Narrative")
	if (locale === "it") return /** @type {LocalizedString} */ ("Narrativa forzata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Принудительный нарратив")
	if (locale === "es") return /** @type {LocalizedString} */ ("Narrativa forzada")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("强制叙事")
	if (locale === "ja") return /** @type {LocalizedString} */ ("強制ナレーション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अनिवार्य आख्यान")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Narrativa forçada")
	return /** @type {LocalizedString} */ ("Forced Narrative")
});